import { render, staticRenderFns } from "./userMpopup.vue?vue&type=template&id=5dd6a167"
import script from "./userMpopup.vue?vue&type=script&lang=js"
export * from "./userMpopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports